module.exports = __webpack_public_path__ + "static/media/locationIconGreen.08aae6b1.svg";